import { Switch } from '@mui/material';
import { PanelBottomClose } from 'lucide-react';
import { ChangeEvent, useCallback } from 'react';
import { SettingsSection, SettingsSectionRow } from 'src/components/SettingsSection';
import { useComposerStartFoldedSetting } from 'src/graphql/entities/user-setting-value';
import { useChatInputStore } from 'src/store/chat-input';

export const ComposerPreferences = () => {
  const [startFolded, setStartFolded] = useComposerStartFoldedSetting();
  const resetChatInputCollapsed = useChatInputStore.use.resetChatInputCollapsed();

  // An explicit choice here outranks the fold the user left behind earlier in this session.
  const onStartFoldedChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setStartFolded(event.target.checked);
      resetChatInputCollapsed();
    },
    [setStartFolded, resetChatInputCollapsed],
  );

  return (
    <SettingsSection
      title="Composer"
      description="Your own defaults for the conversation composer. They follow you across devices."
    >
      <SettingsSectionRow
        icon={<PanelBottomClose />}
        title="Start with the composer folded"
        secondary="Open conversations with the composer folded into the Reply / Add note strip, so the timeline gets the room."
        control={
          <Switch
            checked={startFolded === true}
            onChange={onStartFoldedChange}
            slotProps={{ input: { 'aria-label': 'Start with the composer folded' } }}
          />
        }
      />
    </SettingsSection>
  );
};
